import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

const CONFIG_PATH = "/benchmarking/configuration";

export const saveBenchmarkConfig = async ({ config = {}, label = null }) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(CONFIG_PATH, { config, label });
  return res.data?.data ?? null;
};

export const getCurrentBenchmarkConfig = async () => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(CONFIG_PATH);
  return res.data?.data ?? null;
};

export const getBenchmarkConfigVersions = async ({ page = 0, limit = 20 } = {}) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(`${CONFIG_PATH}/versions`, {
    params: { page, limit },
  });
  const body = res.data || {};
  return {
    data: Array.isArray(body.data) ? body.data : [],
    total: body.total ?? 0,
    page: body.page ?? page,
  };
};

export const getBenchmarkConfigVersion = async (version) => {
  const axios = AxiosConfigExplore();
  const res = await axios.get(`${CONFIG_PATH}/versions/${version}`);
  return res.data?.data ?? null;
};

export const rollbackBenchmarkConfig = async ({ target_version, label = null }) => {
  const axios = AxiosConfigExplore();
  const res = await axios.post(`${CONFIG_PATH}/rollback`, {
    target_version,
    ...(label != null ? { label } : {}),
  });
  return res.data?.data ?? null;
};
